import React, { createRef, useEffect, } from "react";

// reactstrap components
import {
    Container,
} from "reactstrap";

// core components
import useWindowSize from "../../useWindowSize"
import useOffsetY from "../../useOffsetY"

// assets

function EventVideo({ placeholder }) {

    // get Height of current viewport
    const { height } = useWindowSize()
    // get video tag
    const videoRef = createRef();
    // get current Y axis value
    const { offsetY } = useOffsetY()

    useEffect(() => {
        // set timeout is needed because chrome throws an error/warning if not
        setTimeout(() => {
            if (offsetY < height) {
                videoRef.current && videoRef.current.play()
            }
            else {
                //Pause video if the video is out of view
                videoRef.current && videoRef.current.pause()
            }
        }, 200);
    }, [videoRef, offsetY, height])

    return (
        <>
            {/* Video */}
            <div className="header-4">
                <div className="header-wrapper" >
                    <div className="page-header header-video fullBg" style={{ display: "flex", alignContent: "center", justifyContent: "center", backgroundColor: "black" }}>
                        {/* We show the video image placeholder instead of the video for small devices */}
                        <div
                            className="page-header flex-centered section-dark"
                            style={{
                                backgroundImage: `url('${placeholder?.img}')`,
                                zIndex: 0,
                                filter: "blur(10px)"
                            }}
                        />
                        <video
                            id="video-source"
                            loop="loop"
                            muted="muted"
                            preload="auto"
                            volume="0"
                            ref={videoRef}
                            poster={placeholder?.img}
                            style={{ minHeight: "100vh", minWidth: "100vw", zIndex: 1 }}
                        >
                            {/* Video Source - edit this if you want to update */}
                            <source
                                src={require("assets/portfolio/video1.mp4")}
                                type="video/mp4"
                            ></source>
                            Video not supported
                        </video>
                        <div className="filter" />
                        <div className="content-center">
                            <Container className="upper-container text-center">
                                <div className="video-text">
                                    {/* <h2>Our</h2> */}
                                    <h1 className="title-uppercase title-no-upper-margin" style={{ fontSize: "7vh" }}>
                                        Our Portfolio
                                    </h1>
                                </div>
                                <br />
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EventVideo;
